import { MILL_1 } from "@/setup/mill-config/mill-config";
import {
	routeM1TestShackManager,
	routeM1TestShackSheet,
} from "@/setup/routes/products.routes";
import { TestShackManagerShiftRedirect } from "../../manager/components/TestShackManagerShiftRedirect";
import { TestShackManagerPage } from "../../manager/TestShackManagerPage";

export const M1TestShackManager = () => {
	return (
		<TestShackManagerPage
			assetId={MILL_1.id}
			sheetRoute={routeM1TestShackSheet}
		/>
	);
};

export const M1TestShackManagerShift = () => (
	<TestShackManagerShiftRedirect managerRoute={routeM1TestShackManager} />
);
